import {
  IRequirementResponse,
  RequirementExpirationStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorIsRequirementExpired = (
  requirement: IRequirementResponse
) => {
  return requirement.expirationStatus === RequirementExpirationStatus.Expired;
};
